module.exports = __webpack_public_path__ + "ae521e44.svg";